module.exports = __webpack_public_path__ + "img/co2_small.5ae1b78d.svg";